// Homepage order within a user group: display_position ascending, unpositioned agents last (newest first).
export const compareAgentOrder = (a, b) => {
  const pa = a.display_position ?? Number.POSITIVE_INFINITY;
  const pb = b.display_position ?? Number.POSITIVE_INFINITY;
  if (pa !== pb) return pa - pb;
  return new Date(b.CreatedAt || 0) - new Date(a.CreatedAt || 0);
};
